import React, { useState, useEffect, useRef } from "react";
import "../css/Navbarlanding.css";
import { useNavigate, useLocation } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import { toast } from "react-toastify";

const Navbarlanding = () => {
  const [activeLink, setActiveLink] = useState("HOME");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [fixedMobileJoinDropdown, setFixedMobileJoinDropdown] = useState(false);
  const [fixedMobileLoginDropdown, setFixedMobileLoginDropdown] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { token, userType } = useAuthStore();
  
  const dropdownRef = useRef(null);
  const loginDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (loginDropdownRef.current && !loginDropdownRef.current.contains(event.target)) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    setLoginDropdownOpen(false);
  };

  const loginToggle = () => {
    setLoginDropdownOpen((prev) => !prev);
    setIsDropdownOpen(false);
  };

  const handleLoginRedirect = (selectedUserType) => {
    if (token && userType) {
      if (userType !== selectedUserType) {
        toast.error(`You are already logged in as a ${userType}`);
        return;
      }
      
      if (userType === "builder") {
        navigate("/builder/dashboard");
      } else {
        navigate("/customer/projectinvite");
      }
    } else {
      navigate(`/login?type=${selectedUserType}`);
    }
    
    setIsDropdownOpen(false);
    setLoginDropdownOpen(false);
    setIsMobileMenuOpen(false);
    setFixedMobileJoinDropdown(false);
    setFixedMobileLoginDropdown(false);
  };

  const toggleMenu = () => {
    if (isMobileMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMobileMenuOpen(false);
        setIsClosing(false);
      }, 1000);
    } else {
      setIsMobileMenuOpen(true);
    }
  };

  const handleActiveLink = (navlink, event) => {
    event.preventDefault();
    setActiveLink(navlink);
    if(navlink === "HOME") {
      navigate("/");
    }
    if(navlink === "SUPPORT") {
      navigate("/support");
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToServices = () => {
    const servicesSection = document.querySelector("#services");
    if (servicesSection) {
      const yOffset = servicesSection.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
    setActiveLink("SERVICES");
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-[90rem] mx-auto px-2 py-3 sm:px-4 lg:px-6">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate("/")}>
            <img
              src="/assets/white background.jpg"
              alt="Ducktail"
              className="h-8 sm:h-14"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex space-x-3 items-center">
            <a
              href=" "
              onClick={(e) => handleActiveLink("HOME", e)}
              className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 ${
                activeLink === "HOME" ? "text-gray-500" : "text-black"
              }`}
            >
              HOME
            </a>
            {/* <a
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                navigate('/#services');
                setActiveLink("SERVICES");
                setIsMobileMenuOpen(false);
              }}
              className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 ${
                activeLink === "SERVICES" ? "text-gray-500" : "text-black"
              }`}
            >
              SERVICES
            </a> */}

            {/* JOIN US Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={toggleDropdown}
                className="relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100"
              >
                JOIN US
              </button>
              {isDropdownOpen && (
                <div className="absolute left-0 mt-2 bg-gray-100 rounded shadow-lg">
                  <button
                    onClick={() => handleLoginRedirect("builder")}
                    className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                  >
                    Builder
                  </button>
                  <button
                    onClick={() => handleLoginRedirect("customer")}
                    className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                  >
                    Customer
                  </button>
                </div>
              )}
            </div>

            {/* <a
            //   href=" "
            //   onClick={(e) => handleActiveLink("CAREER", e)}
            //   className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 ${
            //     activeLink === "CAREER" ? "text-gray-500" : "text-black"
            //   }`}
            // >
            //   JOB PORTAL
            // </a> */}
            <a
              href=" "
              onClick={(e) => handleActiveLink("SUPPORT", e)}
              className={`relative px-4 py-2 text-[14px] font-bold transition-all hover:rounded-full duration-300 hover:text-gray-500 hover:bg-gray-100 ${
                activeLink === "SUPPORT" ? "text-gray-500" : "text-black"
              }`}
            >
              SUPPORT
            </a>
            
            {/* Login Dropdown */}
            <div className="hidden lg:block" ref={loginDropdownRef}>
              <button
                onClick={loginToggle}
                className="bg-blue-600 text-white font-bold px-6 py-2 rounded-full hover:bg-blue-700"
                style={{ marginLeft: "60px" }}
              >
                Login
              </button>
              {loginDropdownOpen && (
                <div className="absolute mt-2 bg-gray-100 rounded shadow-lg">
                  <button
                    onClick={() => handleLoginRedirect("builder")}
                    className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                  >
                    Builder
                  </button>
                  <button
                    onClick={() => handleLoginRedirect("customer")}
                    className="block w-full text-left px-4 py-2 text-black hover:bg-gray-200"
                  >
                    Customer
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className="text-black p-2 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white rounded-lg mt-2 shadow-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a
                href=" "
                onClick={(e) => handleActiveLink("HOME", e)}
                className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                HOME
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToServices();
                }}
                className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                SERVICES
              </a>
              
              {/* JOIN US Mobile Dropdown */}
              <div className="relative">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setFixedMobileJoinDropdown(!fixedMobileJoinDropdown);
                    setFixedMobileLoginDropdown(false);
                  }}
                  className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                >
                  JOIN US
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {fixedMobileJoinDropdown && (
                  <div className="pl-4">
                    <button
                      onClick={() => handleLoginRedirect("builder")}
                      className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      Builder
                    </button>
                    <button
                      onClick={() => handleLoginRedirect("customer")}
                      className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      Customer
                    </button>
                  </div>
                )}
              </div>
              
              {/* <a
                href=" "
                onClick={(e) => handleActiveLink("CAREER", e)}
                className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                JOB PORTAL
              </a> */}
              <a
                href=" "
                onClick={(e) => handleActiveLink("SUPPORT", e)}
                className="block px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
              >
                SUPPORT
              </a>
              
              {/* LOGIN Mobile Dropdown */}
              <div className="relative">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setFixedMobileLoginDropdown(!fixedMobileLoginDropdown);
                    setFixedMobileJoinDropdown(false);
                  }}
                  className="flex justify-between items-center w-full px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                >
                  LOGIN
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {fixedMobileLoginDropdown && (
                  <div className="pl-4">
                    <button
                      onClick={() => handleLoginRedirect("builder")}
                      className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      Builder
                    </button>
                    <button
                      onClick={() => handleLoginRedirect("customer")}
                      className="block w-full text-left px-3 py-2 text-black font-medium hover:bg-gray-100 rounded-md"
                    >
                      Customer
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbarlanding;